import { type BlokProps, StoryblokComponent } from "@trydig/storyblok";
import { clsx } from "@trydig/ui";
import type { ComponentProps } from "react";
import { BlokWrap } from "~/components/bloks/BlokWrap";
import type { ContainerStoryblok } from "~/generated/sb/blok-types";
import styles from "./ContainerBlok.module.css";

export const ContainerBlok = ({
	blok,
	className,
	preview,
	...rest
}: BlokProps<ContainerStoryblok> & ComponentProps<"div">) => {
	return (
		<BlokWrap
			editable={blok}
			data-layout="blok"
			data-container="small"
			className={clsx(styles.container, className)}
			{...rest}
		>
			{blok.content?.map((c) => (
				<StoryblokComponent preview={preview} blok={c} key={c._uid} />
			))}
		</BlokWrap>
	);
};
